module.exports = __webpack_public_path__ + "static/media/about-us.081017c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us.svg
// module id = 215
// module chunks = 3